/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2020, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import StringResources from 'nls/StringResources';
import { ShapingAncestorTree } from 'ca-modeller/shaping';
import { Flyout } from '@ba/ba-ui-carbon-toolkit';

class FieldFlyout extends Component {

	_shapingAncestorTree_includeParent = () => true

	render() {
		const { activeDataSourceModule, id, triggerNode, onClose } = this.props;
		const metadataColumn = activeDataSourceModule.value.getMetadataColumn(id);
		const moserColumn = metadataColumn && metadataColumn.moserObject;
		if (moserColumn) {
			return (
				<Flyout
					key={id}
					domNodeToAttachTo={document.body}
					triggerNode={triggerNode}
					offset={0}
					placement={'topCentred'}
					candidatePlacement={['topCentred']}
					onClose={onClose}
				>
					<div className="relationship-vis-view__disambiguatingTooltip">{this._renderQuerySubjectItem(moserColumn)}</div>
				</Flyout>
			);
		}
		return null;
	}

	_renderQuerySubjectItem(moserColumn) {
		const tooltipLabel = StringResources.get('relationshipGraph_source_tooltip_label_title');
		const shapingHelper = this.props.activeDataSourceModule.value.getShapingHelper();
		return (
			<div>
				<div className="relationship-vis-view__disambiguatingTooltipTitle">{tooltipLabel}</div>
				<shapingHelper.ShapingProvider>
					<ShapingAncestorTree
						includeParent={this._shapingAncestorTree_includeParent}
						moserObject={moserColumn}
					/>
				</shapingHelper.ShapingProvider>
			</div>
		);
	}

}

FieldFlyout.propTypes = {
	onClose: PropTypes.func,
	triggerNode: PropTypes.node.isRequired,
	activeDataSourceModule: PropTypes.object.isRequired,
	id: PropTypes.string.isRequired
};

FieldFlyout.defaultProps = {
	onClose: () => {}
};

export default FieldFlyout;


// WEBPACK FOOTER //
// ./src/js/components/fieldsList/FieldFlyout.js